import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { call } from '../../lib/api.ts';

export function PayoutEnvironment() {
  const { t } = useTranslation();
  const status = useQuery({ queryKey: ['payout-environment'], queryFn: () =>
    call<{ environment: string }>('/api/payout/environment', { cache: 'no-store' }) });
  const environment = status.data?.environment;
  return <header className="workspace-route-counters" role="status">
    {t(environment === 'sandbox' ? 'settle.environment.sandbox' : environment === 'production' ? 'settle.environment.production' : 'settle.environment.unknown')}
  </header>;
}
